<div class="section-content py-8 flex-gap" [class.animate]="activeMenu">
  <ng-container *ngFor="let menu of activeMenu">
    <ng-container *ngFor="let column of menu.column">
      <digital-platform-inline-image-nav
        *ngIf="column.link_image_url"
        [config]="column"
      ></digital-platform-inline-image-nav>
    </ng-container>
  </ng-container>

  <ng-container *ngFor="let menu of activeMenu">
    <div class="rsx-rich-text-container" *ngIf="shouldRender(menu)">
      <ng-container
        *ngFor="
          let column of menu.column;
          let isFirst = first;
          let isLast = last
        "
      >
        <digital-platform-rsx-rich-text
          *ngIf="isFirst"
          [class]="column.link_style"
          [body]="column.link_title || ''"
          [attr.data-automation-id]="column.link_title"
          >{{ column.link_title }}</digital-platform-rsx-rich-text
        >
        <digital-platform-rsx-a
          *ngIf="!column.link_image_url && !isFirst"
          klass="text-decoration-none"
          [url]="column.link_url || ''"
          [target]="getTarget(column.link_a_target, column.link_url)"
          [class]="column.link_style"
          styling="color: #000"
          [attr.title]="column.link_title"
          [attr.data-automation-id]="column.link_title"
          >{{ column.link_title }}</digital-platform-rsx-a
        >
        <digital-platform-cta-button
          class="auto-margin-top"
          *ngIf="menu.view_all_link && isLast"
          [ctaStyle]="viewAllLinkStyle"
          [url]="getViewAllLinkUrl(menu.view_all_link)"
          >View All</digital-platform-cta-button
        >
      </ng-container>
    </div>
  </ng-container>
</div>
